<template>
  <div class="px-5">
    <v-data-table :headers="headers" :items="dataFinancialIndex" class="elevation-1">
      <template v-slot:items="props">
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-left">{{ props.item.name_fantasy }}</td>
        <td class="text-xs-left">{{props.item.area}}</td>
        <td class="text-xs-center">
          <v-btn flat icon @click="openForm(props.item)">
            <v-icon small>edit</v-icon>
          </v-btn>
          <!-- <v-icon small class="mr-2" @click="editItem(props.item)">edit</v-icon> -->
        </td>
      </template>
    </v-data-table>
    <!-- <EditAccPlans
      :getFinancialIndex="getFinancialIndex"
      :editAccPlanDialog="editAccPlanDialog"
      :expenseData="expenseData"
      :closeEditAccPlanDialog="closeEditAccPlanDialog"
    />-->
  </div>
</template>
<script>
import EditFinancialIndex from "./RegisterFinancialIndex";
export default {
  methods: {
    closeEditAccPlanDialog() {
      this.editAccPlanDialog = false;
    }
  },
  components: {
    //EditAccPlans
  },
  props: {
    openForm: Function,
    dataFinancialIndex: Array,
    getFinancialIndex: Function
  },
  data() {
    return {
      expenseData: {},
      editAccPlanDialog: false,
      headers: [
        {
          text: "Índice",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "Condomínio",
          align: "left",
          sortable: false,
          value: "name_fantasy"
        },
        {
          text: "Área",
          align: "left",
          sortable: false,
          value: "area"
        },
        {
          text: "Ações",
          align: "center",
          sortable: false,
          value: "acions"
        }
      ]
    };
  }
};
</script>